<template>
<div id="login-box">
    <layout-customs>
        <!-- Page Content -->
        <div class="login-box">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-lg-5 col-sm-5">
                        <div class="login-left">
                            <h3 class="headline-1 login-title">Welcome to<br> Greeneum Energy<br> Platform</h3>
                            <div v-if="isLogin == false || activated == false" class="signIn">
                              <div class="row" v-if="validationMessage">
                                  <div class="col-md-8 error subtitle-2">
                                      {{validationMessage}}
                                  </div>
                              </div>
                              <div class="row first">
                                <div class="col-md-12 social-line">
                                  <ul>
                                    <li>
                                      <g-signin-button
                                        class="soc"
                                        :params="googleSignInParams"
                                        @success="signInWithGoogleSuccess"
                                        @error="signInError"
                                      >
                                           <a><i class="fa fa-google-plus-square" aria-hidden="true"></i></a>
                                      </g-signin-button>  

                                      <!-- <a href=""><i class="fa fa-google-plus-square" aria-hidden="true"></i></a> -->
                                    </li>
                                    <li>
                                      <fb-signin-button
                                        class="soc"
                                        :params="fbSignInParams"
                                        @success="signInWithFacebookSuccess"
                                        @error="signInError"
                                      >
                                          <a><i class="fa fa-facebook-square"  aria-hidden="true"></i></a>
                                      </fb-signin-button>
                                      <!-- <a href=""><i class="fa fa-facebook-square"  aria-hidden="true"></i></a> -->

                                      </li>
                                      <li><a @click="liLogin"><i class="fa fa-linkedin-square" aria-hidden="true"></i></a></li>
                                  </ul>
                                </div>
                                  <div class="col-md-8">
                                      <input
                                          type="text"
                                          name="email"
                                          autocomplete="login"
                                          v-validate="'required|email'"
                                          v-model="email"
                                          class="form-control"
                                          :class="{'error-input': errors.has('email')}"
                                          placeholder="Email"
                                          v-on:keyup.enter="signIn"
                                      >
                                      <span
                                          class="error"
                                          v-if="errors.has('email')"
                                      >{{errors.first('email')}}</span>
                                  </div>
                              </div>
                              <div class="row">
                                  <div class="col-md-8">
                                      <input
                                          type="password"
                                          name="password"
                                          autocomplete="new-password"
                                          v-validate="'required|min:6'"
                                          class="form-control"
                                          v-model="password"
                                          placeholder="Password"
                                          :class="{'error-input': errors.has('password')}"
                                          id="password" 
                                          v-on:keyup.enter="signIn"
                                      >
                                          <!-- data-toggle="password" -->
                                      <i class="fa fa-eye-slash toggle-password" aria-hidden="true" @click="togglePassword()"></i>                                      
                                      <span
                                          class="error"
                                          v-if="errors.has('password')"
                                      >{{errors.first('password')}}</span>
                                  </div>
                                  <div class="col-md-2">
                                    <button v-on:click="signIn()" class="go" >Go</button>
                                  </div>
                              </div>
                              <div class="row">
                                  <div class="col-md-8">
                                    <router-link to="/forgot" class="btn-forgot-password">Forgot Password</router-link>
                                  </div>
                              </div>
                              <div class="row">
                                  <div class="col-md-8">
                                    <router-link to="/signup" class="btn-w">Register</router-link>
                                  </div>
                              </div>
                            </div>
                            <div v-else class="subtitle-1" style="font-weight: 500;color: white;">
                              <div v-if="activated">Email confirmed, Thank you.
                                <router-link to="/dashboard" class="btn-forgot-password subtitle-1">Enter</router-link> Energy Platform
                              </div>  
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-7 col-sm-7">
                        <div class="login-right">
                            <img src="/static/dist/images/login-img.png">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </layout-customs>
</div>
</template>
<style>
.input-group-addon {
  padding: 2px 2px !important;
  background-color: unset !important;
  border: none;

}
.fa-eye, .fa-eye-slash {
    position: absolute;
    right: -16px;
    top: 10px;
    font-size: 18px;
    color: #55be68;
    background: #fff;
    padding: 4px;
    border-radius: 6px;
    cursor: pointer;
    z-index: 1;
}
.btn-w {
  margin-left: 0px !important;
  margin-top: 20px;
}

</style>
<script>
import LayoutCustoms from './../../layouts/LayoutDefault.vue';
import Api from './../../services/api'
import User from './../../services/auth'

export default {
  name: 'project',
  props: [],
  components: {
    LayoutCustoms,
    Api,
    User
  },
  data() {
    return {
      isLogin: false,
      email: '',
      password: '',
      validationMessage: '',
      activationMessage: null,
      fbSignInParams: {
        scope: 'email,user_likes',
        return_scopes: true,
      },
      googleSignInParams: {
        client_id:
          '459260954938-kpc63h85vmpjr5ribmj74u15spiko6ns.apps.googleusercontent.com',
      },
      activated: false,
    }
  },
  methods: {
    togglePassword() {
        $(".toggle-password").toggleClass("fa-eye fa-eye-slash");
        var x = document.getElementById("password");
          if (x.type === "password") {
            x.type = "text";
          } else {
            x.type = "password";
          }
    },
    async signIn() {
      try {
        var validation = await this.$validator.validateAll()
        if (!validation) {
          return
        }
        var response = await Api.signIn(this.email, this.password)
        this.isLogin = true;
        window.location.href = '/dashboard'
      } catch (error) {
        console.error(error)
        if (error.message) {
          this.validationMessage = error.message
        } else {
          this.validationMessage = 'Login or password is wrong.*****'
        }
      }
    },
    liLogin_OLD() {
      var _s = this;
      window.IN.user.authorize().then(function(){
        _s.signInWithLinkedinSuccess()
      })
      // window.IN.user.authorize().then(function(data){
      //               console.log("Logged in successfully .");
      //               window.IN.API.Raw("/people/~:(id,first-name,last-name,formatted-name,headline,location,industry,current-share,num-connections,num-connections-capped,summary,specialties,positions,picture-url,site-standard-profile-request,api-standard-profile-request,public-profile-url,email-address)").method("GET").body().result(function (oData) {
      //                   that.props.dispatch(userCreation(linkedInProfileFormat(oData)));
      //               });
      //           },function(error){
      //               alert("Linkedin failed because of harshita !");
      //           });
    },
    liLogin() {
      // IN.UI.Authorize()
      //   .params({ scope: ['r_basicprofile', 'r_emailaddress'] })
      //   .place()
      // IN.Event.on(IN, 'auth', this.signInWithLinkedinSuccess)
       window.location.href = "/auth/linkedin"
      // var _s = this;
      // this.$http.get("https://www.linkedin.com/uas/oauth2/authorization?response_type=code&client_id=78ut2ssnk4xz9v&redirect_uri=http://localhost:8080&state=DCEeFWf45A53sdfKef353&scope=r_basicprofile")
      // .then( response => {
      //           console.log("User AUTH LINKEDIN ***********************")
      //           console.log(response)
      //         },
      //         error => {
      //           _s.validationMessage = 'User error. I can not log in.'
      //         })
    },
    signInWithLinkedinSuccess() {
      // Use the API call wrapper to request the member's basic profile data
      var profile = {},
        _s = this
      IN.API.Profile('me')
        .fields(
          'id,firstName,lastName,email-address,picture-url,public-profile-url,location:(name)'
        )
        .result(function(me) {
          console.log("me>>>>>>>>>>>>>>>>>>>")
          console.log(me)
          profile = me.values[0]
          var id = profile.id
          var firstName =
            profile.firstName == undefined ? '' : profile.firstName
          var lastName = profile.lastName == undefined ? '' : profile.lastName
          var emailAddress = profile.emailAddress
          var pictureUrl =
            profile.pictureUrl == undefined
              ? ''
              : profile.pictureUrl
          // var profileUrl = profile.publicProfileUrl;
          // var country = profile.location.name;

          _s.$http
            .post('/socialauth', {
              email: emailAddress,
              socialType: 'in',
              first_name: firstName,
              last_name: lastName,
              picture: pictureUrl,
            })
            .then(
              response => {
                User.setUserData(response.data.user)
                // console.log("User.setUserData(response.data.user)")
                // console.log(response.data.user)
                _s.user = response.data.user.email
                _s.$router.push('/dashboard')
              },
              error => {
                _s.validationMessage = 'User error. I can not log in.'
              }
            )
        })
    },
    signInWithGoogleSuccess(response) {
      const profile = response.getBasicProfile()
      // console.log('profile google >>>>>>>>>>>>>>>>>>>>>>')
      // console.log(profile)
      this.$http
        .post('/socialauth', {
          email: profile.U3,
          socialType: 'gl',
          first_name: profile.ofa,
          last_name: profile.wea,
          picture: profile.Paa,
        })
        .then(
          response => {
            User.setUserData(response.data.user)
            this.user = response.data.user.email
            this.$router.push('/dashboard')
          },
          error => {
            this.validationMessage = 'Problems with login. Try again.'
            console.error(error)
          }
        )
    },
    signInWithFacebookSuccess(response) {
      FB.api(
        '/me',
        { fields: 'id, first_name, last_name, email, name, picture' },
        dude => {
          console.log('dude')
          console.log(dude)
          console.log(dude.picture.data.url)
          this.$http
            .post('/socialauth', {
              email: dude.email,
              socialType: 'fb',
              first_name: dude.first_name,
              last_name: dude.last_name,
              picture: dude.picture.data.url,
            })
            .then(
              response => {
                User.setUserData(response.data.user)
                this.user = response.data.user.email
                this.$router.push('/dashboard')
              },
              error => {
                this.validationMessage = 'Problems with login. Try again.'
                console.error(error)
              }
            )
        }
      )
    },
    signInError(error) {
      this.validationMessage = 'Problems with login. Try again.'
      console.error(error)
    },
    signInWithTwitter() {
      window.location.href = '/request-token'
    },
    signUp() {
      window.location.href = '/signup'
    },
    forgot() {
      window.location.href = '/forgot'
    },
    onAutoFill(me, callback) {
      var last = $(me).val()
      var infunc = function() {
        var text = $(me).val()
        if (text != last) {
          last = text
          callback(me)
          return
        }
        setTimeout(infunc, 100)
      }
      setTimeout(infunc, 100)
    },
  },
  created() {
    if (this.$route.path == '/twitter/callback') {
      this.$http.get('/access-token' + location.search).then(
        response => {
          User.setUserData(response.data.user)
          this.user = response.data.user.email
          this.$router.push('/dashboard')
        },
        error => {
          this.validationMessage = 'Problems with login. Try again.'
          console.error(error)
        }
      )
    }
    else  if (this.$route.path == '/linkedin') {
          // console.log(" search linkedin")
          var search = location.search.substring(1);
          var s = search.substr(search.indexOf("&image=http")+7, search.length)
          var data = search?JSON.parse('{"' + search.replace(/&/g, '","').replace(/=/g,'":"') + '"}',
                 function(key, value) { return key===""?value:decodeURIComponent(value) }):{}
          var img = decodeURIComponent(s)
          data.image = img

          User.setUserData(data)
          this.user = data.email
          // this.$router.push('/dashboard')
    }
  },
  beforeMount() {
    if (User.isLogin()) {
      window.location.href = '/dashboard'
    }
  },
  mounted() {

  //   this.setHeightImage()

  //   window.addEventListener('resize', this.handleResize)

  //   this.onAutoFill(
  //     'input[type="email"]:-webkit-autofill,input[type="password"]:-webkit-autofill',
  //     function(input) {
  //       $(input)
  //         .siblings('label')
  //         .addClass('active')
  //     }
  //   )
  // },
  // beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
    // console.log("this.$route************************************** 1 " + this.$route.params.id)
    if (this.$route.params.id) {
      // console.log("this.$route**************************************")
      // console.log(this.$route)
      this.$http.post('/activated', { token: this.$route.params.id }).then(
        response => {
          // console.log("response=========================================")
          this.isLogin = true;
          this.activated = true;
          User.setUserData(response.data.user)
          this.activationMessage = '<div class="subtitle-1" style="font-weight: 500;color: white;">Email confirmed, Thank you.<br><a hreg="/">Enter</a> Energy platform.</div>'
          // console.log(response)
        },
        error => {
          this.activationMessage = "Token expired, try to register again."
          console.log(error)
        }
      )
    }

  },
}
</script>



// WEBPACK FOOTER //
// src/components/Account/SignIn.vue